import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController,
} from "ionic-angular";
import * as _ from "lodash";
import { CalendarService } from "../../../providers/calendar-service/calendar-service";

@IonicPage()
@Component({
  selector: "page-status-view-popover",
  templateUrl: "status-view-popover.html",
})
export class StatusViewPopoverPage {
  public eventStatus: boolean = false;
  public message: boolean = false;
  assigneeList: any;
  constructor(
    public navCtrl: NavController,
    private calendarService: CalendarService,
    public navParams: NavParams,
    public viewCtrl: ViewController
  ) {
    let id = this.navParams.data.id;
    this.getresponseStatus(id);
  }
  close() {
    this.viewCtrl.dismiss();
  }
  taskListEventResponse(data) {
    let attendeeList = [];
    attendeeList = _.filter(data, (ele) => {
      return !_.has(ele, "displayName");
    });
    return attendeeList;
  }
  getresponseStatus(id) {
    // this.eventStatus = false;
    // this.calendarService.getResponseStatus(window.localStorage.calendarID, id)
    //   .subscribe(response => {
    //     let attendeeList = this.taskListEventResponse(response);
    //     if (!(_.isEmpty(attendeeList))) {
    //       this.assigneeList = attendeeList;
    //     } else {
    //       this.message = true;
    //     }
    //     this.eventStatus = true;
    //   });
    // (err: any) => {
    //   console.log(err.message);
    //   this.eventStatus = true;
    // }
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/status-view-popover/status-view-popover.ts